/**
 * LastUsersOrderBy
 *
 * Sort field for the Latest Users list. Matches Flutter's `LastUsersOrderBy`
 * enum order EXACTLY (createdTimestamp first, lastSeenTimestamp second).
 * Source: lib/domain/enums/last_users_order_by.dart
 *
 * `getLastUsersOrderByField` mirrors the Flutter `LastUsersOrderByExtension.field`
 * getter, returning the literal Firestore document field name to order by.
 */
export enum LastUsersOrderBy {
  CREATED_TIMESTAMP = 'createdTimestamp',
  LAST_SEEN_TIMESTAMP = 'lastSeenTimestamp',
}

/**
 * Resolve the Firestore field name to order by for the given sort option.
 * Matches Flutter: lib/domain/enums/last_users_order_by.dart:3-12.
 */
export function getLastUsersOrderByField(orderBy: LastUsersOrderBy): string {
  switch (orderBy) {
    case LastUsersOrderBy.CREATED_TIMESTAMP:
      return 'created_timestamp';
    case LastUsersOrderBy.LAST_SEEN_TIMESTAMP:
      return 'last_seen_timestamp';
  }
}
